module.exports = __webpack_public_path__ + "static/media/img-tooltip.2aa07e22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-tooltip.svg
// module id = 611
// module chunks = 0